module.exports = __webpack_public_path__ + "static/media/AppGallery.f4d679ab.png";